define(["require", "exports", "../design"], function (require, exports, design_1) {
    "use strict";
    exports.__esModule = true;
    function hasTouch() {
        return 'ontouchstart' in window;
    }
    exports.hasTouch = hasTouch;
    function hasDragStart() {
        return 'ondragstart' in window;
    }
    exports.hasDragStart = hasDragStart;
    exports.isTrident = navigator.userAgent.indexOf('Trident/') >= 0;
    exports.isEdge = navigator.userAgent.indexOf('Edge/') >= 0;
    exports.isFirefox = navigator.userAgent.indexOf('Firefox/') >= 0;
    exports.isChrome = navigator.userAgent.indexOf('Chrome/') >= 0;
    exports.isSafari = navigator.userAgent.indexOf('Safari/') >= 0 && !exports.isChrome;
    exports.isIOS = navigator.userAgent.indexOf('AppleWebKit') >= 0 && navigator.userAgent.match(/iP(od|hone|ad)/) !== null;
    function hasNativeDragDrop() {
        return !hasTouch() && hasDragStart() && !exports.isFirefox && !exports.isSafari;
    }
    exports.hasNativeDragDrop = hasNativeDragDrop;
    function createDataTransfer() {
        var dt = null;
        try {
            dt = new DataTransfer();
        }
        catch (ex) {
            dt = {
                setData: function () { }
            };
        }
        return dt;
    }
    var asPinchZoomSegment = function (te) {
        if (te.touches && te.touches.length === 2) {
            var start = { X: te.touches[0].clientX, Y: te.touches[0].clientY };
            var end = { X: te.touches[1].clientX, Y: te.touches[1].clientY };
            return { start: start, end: end };
        }
        return null;
    };
    function isMultiTouch(te) {
        if (te.type === 'touchstart' || te.type == 'touchmove' || te.type === 'touchend') {
            if (te.touches && te.touches.length > 1) {
                return true;
            }
        }
        return false;
    }
    var isPinchZoomable = function ($cur) { return !!$cur.attr('pinchzoom'); };
    var isDraggable = function ($cur) { return !!$cur.attr('draggable'); };
    var handleTouchKind = function (e) {
        var oe = e.originalEvent;
        var $cur = $(e.currentTarget);
        return isDraggable($cur) && !(isMultiTouch(oe)) ? { kind: 'drag', $cur: $cur, oe: oe } :
            (isPinchZoomable($cur) && !!asPinchZoomSegment(oe) ? { kind: 'pinchzoom', $cur: $cur, oe: oe } : {});
    };
    function handleTouchStart(e) {
        var _a = handleTouchKind(e), kind = _a.kind, oe = _a.oe, $cur = _a.$cur;
        if (!kind) {
            return;
        }
        if (kind === 'pinchzoom') {
            var seg = asPinchZoomSegment(oe);
            if (seg) {
                $cur.data('pinchzoom', seg);
            }
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (oe.type === 'touchstart') {
            var te = oe;
            oe.pointerId = te.touches[0].identifier + 2;
        }
        var dataTransfer = createDataTransfer();
        $cur.data('dragging', dataTransfer);
        try {
            e.currentTarget.setPointerCapture(oe.pointerId);
        }
        catch (ex) {
        }
        var eventType = kind + "start";
        $cur.trigger(eventType, {
            originalEvent: $.extend({}, oe, {
                type: eventType, dataTransfer: dataTransfer,
                clientX: oe.clientX || oe.changedTouches[0].clientX,
                clientY: oe.clientY || oe.changedTouches[0].clientY
            })
        });
        e.stopImmediatePropagation();
        return false;
    }
    function handleTouchMove(e) {
        var _a = handleTouchKind(e), $cur = _a.$cur, oe = _a.oe, kind = _a.kind;
        if (!kind) {
            return;
        }
        if (kind === 'pinchzoom') {
            var prevSeg = $cur.data('pinchzoom');
            if (prevSeg) {
                var oe_1 = e.originalEvent;
                var seg = asPinchZoomSegment(oe_1);
                var prevLength = design_1.length(prevSeg);
                var curLength = design_1.length(seg);
                if (curLength !== prevLength && prevLength !== 0) {
                    $cur.trigger('pinchzoom', {
                        pinchzoom: curLength / prevLength
                    });
                }
            }
        }
        e.preventDefault();
        e.stopPropagation();
        var dataTransfer = $cur.data('dragging');
        if (!dataTransfer) {
            dataTransfer = createDataTransfer();
            $cur.data('dragging', dataTransfer);
        }
        $cur.data('dragging', dataTransfer);
        if (kind === 'drag') {
            $cur.trigger(kind, {
                originalEvent: $.extend({}, oe, {
                    type: 'drag',
                    dataTransfer: dataTransfer,
                    clientX: oe.clientX || oe.changedTouches[0].clientX,
                    clientY: oe.clientY || oe.changedTouches[0].clientY
                })
            });
        }
    }
    function handleTouchEnd(e) {
        var _a = handleTouchKind(e), $cur = _a.$cur, oe = _a.oe, kind = _a.kind;
        if (!kind) {
            return;
        }
        var dataTransfer = $cur.data('dragging');
        $cur.data('dragging', false);
        $cur.removeData('pinchzoom');
        e.preventDefault();
        e.stopPropagation();
        if (oe.type === 'touchend') {
            var te = oe;
            oe.pointerId = te.changedTouches[0].identifier + 2;
        }
        try {
            e.currentTarget.releasePointerCapture(oe.pointerId);
        }
        catch (ex) {
        }
        if (kind === 'drag') {
            $cur.trigger('drop', {
                originalEvent: $.extend({}, oe, { type: 'drop', dataTransfer: dataTransfer })
            });
        }
        else {
            $cur.trigger(kind + "end");
        }
    }
    (function ($) {
        $.fn.draggable = function () {
            var $cur = $(this);
            if (hasNativeDragDrop()) {
                return $cur;
            }
            $cur.on('mousedown', handleTouchStart);
            $cur.on('touchstart', handleTouchStart);
            $cur.on('mousemove', handleTouchMove);
            $cur.on('touchmove', handleTouchMove);
            $cur.on('mouseup', handleTouchEnd);
            $cur.on('touchend', handleTouchEnd);
            return $cur;
        };
    })($);
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/draggable.js
// module id = 22
// module chunks = 0